import {
  useCallback, useEffect, useRef, useState,
} from 'react';

export interface PdfViewerControl {
  setZoom: (zoom: number) => void;
  zoomIn: () => void;
  zoomOut: () => void;
  getZoom: () => void;
  currentZoom: number | null;
}

export function usePdfViewerControl(iframeRef: React.RefObject<HTMLIFrameElement>): PdfViewerControl {
  const [currentZoom, setCurrentZoom] = useState<number | null>(null);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data && event.data.type === 'ccPdfStatus') {
        if (typeof event.data.zoom === 'number') {
          setCurrentZoom(event.data.zoom);
        }
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  const sendCommand = useCallback((action: string, value?: any) => {
    if (iframeRef.current && iframeRef.current.contentWindow) {
      iframeRef.current.contentWindow.postMessage({
        type: 'ccPdfControl',
        action,
        value,
      }, '*');
    }
  }, [iframeRef]);

  const setZoom = useCallback((zoom: number) => {
    sendCommand('setZoom', zoom);
  }, [sendCommand]);

  const zoomIn = useCallback(() => {
    sendCommand('zoomIn');
  }, [sendCommand]);

  const zoomOut = useCallback(() => {
    sendCommand('zoomOut');
  }, [sendCommand]);

  const getZoom = useCallback(() => {
    sendCommand('getZoom');
  }, [sendCommand]);

  return {
    setZoom,
    zoomIn,
    zoomOut,
    getZoom,
    currentZoom,
  };
}
